import { render, staticRenderFns } from "./DeletionAlert.vue?vue&type=template&id=28420696&"
import script from "./DeletionAlert.vue?vue&type=script&lang=js&"
export * from "./DeletionAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports